<div class="page-empty-header"></div>

<div class="container-fluid">
  <div class="row">
    <app-configuration-dashboard-menu class="col-2 mobile-sidebar"></app-configuration-dashboard-menu>

    <div class="col-10 mobile-content config-page">

      <header class="config-page-header">
        <nav class="config-breadcrumb" aria-label="Breadcrumb">
          <ol>
            <li *ngFor="let crumb of trail; let last = last">
              <a *ngIf="!last && crumb.routerLink" [routerLink]="crumb.routerLink">{{ crumb.label }}</a>
              <span *ngIf="last || !crumb.routerLink" [attr.aria-current]="last ? 'page' : null">{{ crumb.label }}</span>
              <mat-icon *ngIf="!last" class="config-breadcrumb-sep">chevron_right</mat-icon>
            </li>
          </ol>
        </nav>

        <div class="config-page-header-row">
          <div class="config-page-heading">
            <p *ngIf="eyebrow" class="config-page-eyebrow">{{ eyebrow }}</p>
            <h1 class="config-page-title">{{ title }}</h1>
            <p *ngIf="description" class="config-page-description">{{ description }}</p>
          </div>

          <div class="config-page-actions">
            <ng-content select="[configPageActions]"></ng-content>
          </div>
        </div>

        <ng-content select="[configPageTabs]"></ng-content>
      </header>

      <div class="config-page-body" [class.config-page-body-padded]="contentPadding">
        <ng-content></ng-content>
      </div>

    </div>
  </div>
</div>
